import withStyles from '@mui/styles/withStyles';

import Icon from '../../ReactEvilIcon';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ImageCarousel from '../../general/ImageCarousel.react';
import TranslationToggleNotice from '@/components/general/TranslationToggleNotice.jsx';
import AmenitiesComponent from './hotelInfo/AmenitiesComponent.react';
import { withTranslation } from 'react-i18next';
import { LTR, SUPPORTED_LANGUAGES } from 'arbitrip-common/translation/const';
import Ajax from '@/utils/Ajax';
import { ReactComponent as DisclaimerIcon } from '@/img/hotel_page/disclaimer_icon.svg';

const styles = (theme) => ({
    dialogTitle: {
        padding: '32px 48px 32px',
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '29px',
        color: theme.palette.black.main,
    },
    closeButton: {
        position: 'absolute',
        top: 19,
        right: 19,
        color: '#ccc',
        '&:hover': {
            color: '#666666',
        },
        '[dir="rtl"] &': {
            right: 'auto',
            left: 19,
        },
    },
    evilIcon: {
        width: 32,
        height: 32,
    },
});

const CloseIcon = ({ onClose, classes }) =>
    onClose ? (
        <button
            className={classNames('action', 'close-modal', classes.closeButton)}
            onClick={onClose}
            aria-label="Close"
        >
            <Icon name="ei-close" size="m" className={classes.evilIcon} />
        </button>
    ) : null;

const LoaderComponent = () => (
    <div
        style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(255,255,255,0.6)',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: 20,
        }}
    >
        <i className="fa fa-spin fa-spinner fa-2x" />
    </div>
);
class RoomsCatalogDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            translatedAmenities: null,
            translatedDescription: null,
            translating: false,
            showOriginalRoom: false,
        };
    }
    /**
     * Renders the shared TranslationToggleNotice with page-specific styling.
     */
    renderTranslationToggle(translatedExists) {
        const { profile } = this.props;
        const enableAdvancedTranslation = _.get(profile, 'company.settings.enable_advanced_translation', false);
        if (!enableAdvancedTranslation) return null;
        return (
            <TranslationToggleNotice
                translatedExists={!!translatedExists}
                showOriginal={this.state.showOriginalRoom}
                onToggle={() => this.setState({ showOriginalRoom: !this.state.showOriginalRoom })}
                style={{ marginTop: 0 }}
            />
        );
    }

    componentDidUpdate(prevProps) {
        let { profile, hotel, room, analyticsFunc } = this.props;
        if (!prevProps.open && this.props.open && hotel && room) {
            if (_.isFunction(analyticsFunc)) {
                analyticsFunc(profile.company, hotel, room);
            }
            // Trigger on-demand translation for room-level content if needed
            try {
                const { i18n } = this.props;
                const enableAdvancedTranslation = _.get(
                    this.props.profile,
                    'company.settings.enable_advanced_translation',
                    false,
                );
                if (!enableAdvancedTranslation) return;
                const lang = i18n?.language;
                if (lang && lang === SUPPORTED_LANGUAGES.EN) return;

                const isExpedia = !!room.amenities;
                const amenities = isExpedia
                    ? (room.amenities || []).map((a) => a?.name).filter(Boolean)
                    : room.perks || [];
                const description = isExpedia ? room.description || '' : room.roomDescriptionParagraph || '';

                if (
                    (Array.isArray(amenities) && amenities.length) ||
                    (typeof description === 'string' && description.trim())
                ) {
                    this.setState({ translating: true });
                    Ajax.translateRoom({ amenities, description })
                        .done((res) => {
                            this.setState({
                                translatedAmenities: Array.isArray(res?.amenities) ? res.amenities : null,
                                translatedDescription: typeof res?.description === 'string' ? res.description : null,
                                translating: false,
                            });
                        })
                        .fail(() => {
                            this.setState({ translating: false });
                        });
                }
            } catch (_e) {}
        }
    }

    getNoRoomRender() {
        const { classes, onClose, t } = this.props;

        return (
            <React.Fragment>
                <DialogTitle id="dialog-title" className={classes.dialogTitle} style={{}}>
                    {t('RoomDataMissing')}
                    <CloseIcon onClose={onClose} classes={classes} />
                </DialogTitle>
            </React.Fragment>
        );
    }

    getRoomContentRender() {
        const { room } = this.props;

        if (room.amenities) {
            return this.expediaRoom();
        } else {
            return this.gimmonixRoom();
        }
    }

    expediaRoom() {
        const { room, classes, onClose, roomName, isDev, profile, t, i18n } = this.props;

        const roomSize = _.get(room, 'info.room_size.metre_square');
        const amenitiesListBase = room.amenities.map((amenity) => amenity.name);
        const enableAdvancedTranslation = _.get(profile, 'company.settings.enable_advanced_translation', false);
        const showOriginal = enableAdvancedTranslation ? this.state.showOriginalRoom : false;
        const amenitiesList = enableAdvancedTranslation
            ? showOriginal
                ? amenitiesListBase
                : this.state.translatedAmenities || amenitiesListBase
            : amenitiesListBase;
        const descriptionOriginal = room.description || '';
        const descriptionToRender = enableAdvancedTranslation
            ? showOriginal
                ? descriptionOriginal
                : this.state.translatedDescription || descriptionOriginal
            : descriptionOriginal;

        let name = roomName ?? room.name;
        if (isDev) {
            name += `\n - Expedia: ${room.name}(${room.id})`;
        }

        const title_classes = `${classes.dialogTitle} rooms-catalog-dialog-title`;

        const isExpediaPartner = _.get(profile, 'company.partners_ui.expedia_partner', false);

        const translatedExists =
            enableAdvancedTranslation &&
            i18n?.language &&
            i18n.language !== SUPPORTED_LANGUAGES.EN &&
            ((Array.isArray(amenitiesListBase) && amenitiesListBase.length > 0) ||
                (typeof descriptionOriginal === 'string' && descriptionOriginal.trim()));
        const dir = !enableAdvancedTranslation || showOriginal ? LTR : i18n.dir();
        const transOpts = !enableAdvancedTranslation || showOriginal ? { lng: SUPPORTED_LANGUAGES.EN } : undefined;

        return (
            <React.Fragment>
                <DialogTitle id="dialog-title" className={title_classes}>
                    {name}
                    <CloseIcon onClose={onClose} classes={classes} />
                </DialogTitle>
                <DialogContent>
                    <div className="flex flex-column rooms-catalog-dialog-content">
                        {room.images?.length > 0 && <ImageCarousel images={room.images} type="medium" />}
                        {this.renderTranslationToggle(translatedExists)}
                        <div
                            className={classNames({ [classes.description]: room.images && room.images.length > 0 })}
                            style={{ position: 'relative' }}
                            dir={dir}
                        >
                            <div style={{ visibility: this.state.translating ? 'hidden' : 'visible' }}>
                                {descriptionToRender && (
                                    <div
                                        className="description-wrapper"
                                        dangerouslySetInnerHTML={{
                                            __html: descriptionToRender,
                                        }}
                                    />
                                )}
                                <br />
                                {roomSize && (
                                    <div className="room-size">
                                        <strong>{t('RoomSize')}:</strong> {roomSize} {t('SqMeters')}
                                    </div>
                                )}
                                {room.amenities?.length > 0 && (
                                    <div className="amenities-container">
                                        <div className="amenities-title">{t('RoomAmenities', transOpts)}</div>
                                        <AmenitiesComponent amenities={amenitiesList} />
                                    </div>
                                )}
                                {isExpediaPartner && this.getAvailabilityDisclaimer()}
                            </div>
                            {this.state.translating && <LoaderComponent />}
                        </div>
                    </div>
                </DialogContent>
            </React.Fragment>
        );
    }

    getAvailabilityDisclaimer() {
        const { t } = this.props;
        return (
            <div className="disclaimer disclaimer-flex">
                <DisclaimerIcon />
                <div>{t('DependsOnAvailability')}</div>
            </div>
        );
    }

    gimmonixImageDisclaimer() {
        const { t } = this.props;

        return (
            <div className="disclaimer tooltip-icon">
                <span>{t('ImagesIllustrative')}.&nbsp;</span>
                <a href={t('TermsAndConditionsUrl')} target="_blank" rel="noreferrer">
                    {t('SeeTCForDetails')}
                </a>
            </div>
        );
    }

    gimmonixRoom() {
        const { room, classes, onClose, i18n, t, profile } = this.props;

        const amenitiesListBase = room.perks;
        const enableAdvancedTranslation = _.get(profile, 'company.settings.enable_advanced_translation', false);
        const showOriginal = enableAdvancedTranslation ? this.state.showOriginalRoom : false;
        const amenitiesList = enableAdvancedTranslation
            ? showOriginal
                ? amenitiesListBase
                : this.state.translatedAmenities || amenitiesListBase
            : amenitiesListBase;

        const images = room.images.map((image) => ({
            original: image.imageUrl,
            description: image.imageDescription,
        }));

        if (!images.length) {
            images.push({
                original: '../../img/hotel_page/room_placeholder.png',
            });
        }

        const descriptionOriginal = room.roomDescriptionParagraph || '';
        const descriptionToRender = enableAdvancedTranslation
            ? showOriginal
                ? descriptionOriginal
                : this.state.translatedDescription || descriptionOriginal
            : descriptionOriginal;
        const translatedExists =
            enableAdvancedTranslation &&
            i18n?.language &&
            i18n.language !== SUPPORTED_LANGUAGES.EN &&
            ((Array.isArray(amenitiesListBase) && amenitiesListBase.length > 0) ||
                (typeof descriptionOriginal === 'string' && descriptionOriginal.trim()));
        const dir = !enableAdvancedTranslation || showOriginal ? LTR : i18n.dir();
        const transOpts = !enableAdvancedTranslation || showOriginal ? { lng: SUPPORTED_LANGUAGES.EN } : undefined;

        return (
            <React.Fragment>
                <DialogTitle id="dialog-title" className={classes.dialogTitle}>
                    {room.name}
                    <CloseIcon onClose={onClose} classes={classes} />
                </DialogTitle>
                <DialogContent>
                    <div className="flex flex-column rooms-catalog-dialog-content">
                        {images?.length > 0 && (
                            <ImageCarousel
                                images={images}
                                type="medium"
                                disclaimer={amenitiesList?.length < 6 && this.gimmonixImageDisclaimer()}
                            />
                        )}
                        {this.renderTranslationToggle(translatedExists)}
                        <div
                            className={classNames({ [classes.description]: images && images.length > 0 })}
                            style={{ position: 'relative' }}
                            dir={dir}
                        >
                            <div style={{ visibility: this.state.translating ? 'hidden' : 'visible' }}>
                                {room.roomDescriptionTitle && (
                                    <p>
                                        <strong>{room.roomDescriptionTitle}</strong>
                                    </p>
                                )}
                                {descriptionToRender && (
                                    <div
                                        className="description-wrapper"
                                        dangerouslySetInnerHTML={{
                                            __html: descriptionToRender,
                                        }}
                                    />
                                )}
                                <br />
                                {amenitiesList?.length > 0 && (
                                    <div className="amenities-container">
                                        <div className="amenities-title">{t('RoomAmenities', transOpts)}</div>
                                        <AmenitiesComponent amenities={amenitiesList} />
                                    </div>
                                )}
                            </div>
                            {this.state.translating && <LoaderComponent />}
                        </div>
                    </div>
                </DialogContent>
            </React.Fragment>
        );
    }

    render() {
        const { open, room, onClose } = this.props;

        return (
            <Dialog fullWidth={true} maxWidth="md" transitionDuration={400} open={open} onClose={onClose}>
                {room ? this.getRoomContentRender() : this.getNoRoomRender()}
            </Dialog>
        );
    }
}

RoomsCatalogDialog.propTypes = {
    profile: PropTypes.any,
    room: PropTypes.object,
    roomName: PropTypes.string,
    isDev: PropTypes.bool,
    hotel: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    classes: PropTypes.object,
    analyticsFunc: PropTypes.func,
};

export default withStyles(styles)(withTranslation()(RoomsCatalogDialog));
